import styled from "styled-components";

export const DataCardFooter = styled.div`
  display: flex;
  flex-direction: row-reverse;
  margin-top: 20px;
`;
export const DataTable = styled.div``;
